module.exports = __webpack_public_path__ + "img/close-dark.a0c21eb7.svg";